import React, { useEffect, useState } from "react";

const StartingIn = ({ show, time, maxTimer }) => {
  const [perc, setPerc] = useState(0);
  const [totalTime, setTotalTime] = useState(0);

  useEffect(() => {
    if (show) {
      setTotalTime(maxTimer);
    }
  }, [maxTimer]);
 
  useEffect(() => {
    
    if (show && time && totalTime) {
     
      setPerc((time * 100) / totalTime);
    }
  }, [time, totalTime]);
 
  // if (!show) return null;

  return (
    <div className="text-center mx-auto position-absolute">
      <span className="text-white text-semibold text-xl text-md-2xl text-lg-2xl mb-3">
        Starting in {time}s
      </span>

      <div
        className="start-div m-auto mt-3"
        style={{
          background: `conic-gradient(#F8B731 0% ${perc}%, white ${perc}% 100%)`,
          // mask: "radial-gradient(circle, transparent 60%, black 61%)",
          // WebkitMask: "radial-gradient(circle, transparent 60%, black 61%)"
        }}
      />
    </div>
  );
};

export default StartingIn;
